import {
  generateLanguageQuery,
  optionalI18nString
} from '@/services/dataStore/queries/fragments'

// The stable `categoryId` slug is what comments store, so it maps to `id` here
// rather than the Sanity document `_id`.
export const commentCategoriesQuery = () =>
  `*[_type == "commentCategory"] | order(sortOrder asc) {
    'id': categoryId.current,
    'name': ${generateLanguageQuery('name')},
    ${optionalI18nString('description')},
    'imgURL': icon->imageFile.asset->url
  }`
